"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.drawer.preview': 'Contenido y Vista previa',
    'socialMediaPlan.drawer.ai': 'Análisis IA',
    'socialMediaPlan.drawer.platforms': 'Plataformas',
    'socialMediaPlan.drawer.date': 'Fecha',
    'socialMediaPlan.drawer.type': 'Tipo',
};
